import React from "react";
import i18next from "i18next";

export const t = (key) => i18next.t(key, { ns: "default" });

export class ConsentBanner extends React.Component {
    constructor(props, context) {
        super(props, context);

        // Mode debug: ajouter ?debug_cookie_banner=1 dans l'URL pour toujours afficher la bannière
        const urlParams = new URLSearchParams(window.location.search);
        const forceShow = urlParams.get('debug_cookie_banner') === '1';

        const hasResponded = this.hasUserResponded();

        this.state = {
            closed: forceShow ? false : hasResponded,
            showDetails: false,
        };
    }

    hasUserResponded() {
        const metaPixelConsent = localStorage.getItem("meta-pixel-consent");

        // Afficher la bannière uniquement si meta-pixel-consent est vide
        // (première visite ou après un reset)
        if (metaPixelConsent === null) {
            console.log("[ConsentBanner] meta-pixel-consent is empty, showing banner");
            return false;
        }

        return true; // Ne pas afficher la bannière
    }

    loadMatomo() {
        const consent = localStorage.getItem("matomo-consent");
        if (consent === "accepted") {
            $.ajax({
                type: "GET",
                url:
                    "https://piwik.hawaii.do/index.php?module=API&method=AjaxOptOut.doTrack&format=json",
                jsonp: "callback",
                dataType: "jsonp",
            });
        } else if (consent === "refused") {
            $.ajax({
                type: "GET",
                url:
                    "https://piwik.hawaii.do/index.php?module=API&method=AjaxOptOut.doIgnore&format=json",
                jsonp: "callback",
                dataType: "jsonp",
            });
        }
    }

    loadMetaPixel() {
        const { pixelId } = this.props;
        const consent = localStorage.getItem("meta-pixel-consent");

        // Si pas de consentement enregistré (null/vide), on active par défaut
        // Si consentement = "refused", on n'active pas
        // Si consentement = "accepted", on active
        if (consent === "refused" || !pixelId) {
            return;
        }

        // Load Meta Pixel script
        !(function (f, b, e, v, n, t, s) {
            if (f.fbq) return;
            n = f.fbq = function () {
                n.callMethod
                    ? n.callMethod.apply(n, arguments)
                    : n.queue.push(arguments);
            };
            if (!f._fbq) f._fbq = n;
            n.push = n;
            n.loaded = !0;
            n.version = "2.0";
            n.queue = [];
            t = b.createElement(e);
            t.async = !0;
            t.src = v;
            s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s);
        })(
            window,
            document,
            "script",
            "https://connect.facebook.net/en_US/fbevents.js"
        );

        window.fbq("init", pixelId);
        window.fbq("track", "PageView");
    }

    acceptAll(e) {
        e.preventDefault();
        localStorage.setItem("matomo-consent", "accepted");
        localStorage.setItem("meta-pixel-consent", "accepted");
        this.loadMatomo();
        this.loadMetaPixel();
        this.setState({ closed: true });
    }

    refuseAll(e) {
        e.preventDefault();
        localStorage.setItem("matomo-consent", "refused");
        localStorage.setItem("meta-pixel-consent", "refused");
        this.loadMatomo();
        this.setState({ closed: true });
    }

    savePreferences(e) {
        e.preventDefault();
        const matomoConsent = document.getElementById("matomo-consent").checked
            ? "accepted"
            : "refused";
        const metaPixelConsent = document.getElementById("meta-pixel-consent")
            .checked
            ? "accepted"
            : "refused";

        localStorage.setItem("matomo-consent", matomoConsent);
        localStorage.setItem("meta-pixel-consent", metaPixelConsent);

        this.loadMatomo();
        this.loadMetaPixel();
        this.setState({ closed: true });
    }

    toggleDetails(e) {
        e.preventDefault();
        this.setState({ showDetails: !this.state.showDetails });
    }

    componentDidMount() {
        // Check if user already accepted and load scripts accordingly
        this.loadMatomo();
        this.loadMetaPixel();
    }

    render() {
        const { closed, showDetails } = this.state;
        const { link } = this.props;


        if (closed) {
            console.log("[ConsentBanner] Banner is closed, not displaying");
            return <React.Fragment />;
        }

        console.log("[ConsentBanner] Rendering banner");

        return (
            <div className="cookie-alert consent-banner">
                <div className="cookie-alert-wrapper">
                    <div className="cookie-alert-wrapper-text">
                        <p>
                            {t(
                                "Ce site utilise des cookies pour vous garantir une meilleure expérience et mesurer l'efficacité de nos campagnes."
                            )}
                        </p>
                        {link && (
                            <p>
                                <a href={link}>{t("Plus d'informations.")}</a>
                            </p>
                        )}

                        {showDetails && (
                            <div className="consent-details">
                                <div className="consent-option">
                                    <label>
                                        <input
                                            type="checkbox"
                                            id="matomo-consent"
                                            defaultChecked={true}
                                        />
                                        <span>
                                            {t(
                                                "Cookies d'analyse (Matomo) - Nous aident à comprendre comment vous utilisez notre site"
                                            )}
                                        </span>
                                    </label>
                                </div>
                                <div className="consent-option">
                                    <label>
                                        <input
                                            type="checkbox"
                                            id="meta-pixel-consent"
                                            defaultChecked={true}
                                        />
                                        <span>
                                            {t(
                                                "Cookies publicitaires (Meta Pixel) - Permettent de mesurer l'efficacité de nos publicités"
                                            )}
                                        </span>
                                    </label>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="btn-wrapper">
                        {!showDetails ? (
                            <>
                                <a
                                    className="btn-std btn-accept"
                                    onClick={(e) => this.acceptAll(e)}
                                >
                                    {t("Tout accepter")}
                                </a>
                                <a
                                    className="btn-std btn-refuse"
                                    onClick={(e) => this.refuseAll(e)}
                                >
                                    {t("Tout refuser")}
                                </a>
                                <a
                                    className="btn-std btn-customize"
                                    onClick={(e) => this.toggleDetails(e)}
                                >
                                    {t("Personnaliser")}
                                </a>
                            </>
                        ) : (
                            <>
                                <a
                                    className="btn-std btn-save"
                                    onClick={(e) => this.savePreferences(e)}
                                >
                                    {t("Enregistrer mes choix")}
                                </a>
                                <a
                                    className="btn-std btn-back"
                                    onClick={(e) => this.toggleDetails(e)}
                                >
                                    {t("Retour")}
                                </a>
                            </>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}
